// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__ZAn6q","sendOtp":"AuthorizeToLogin_sendOtp__iCVGf"};